import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Target, Video } from 'lucide-react';
const items = [{
  label: 'Guía principal',
  icon: BookOpen,
  title: 'Sistema iPhone Ads',
  subtitle: 'Guía práctica',
  accent: 'from-blue-600 to-blue-800'
}, {
  label: 'Bonus 1',
  icon: Target,
  title: 'Estructura de Campañas',
  subtitle: 'Instagram Ads para iPhones',
  accent: 'from-zinc-700 to-zinc-900'
}, {
  label: 'Bonus 2',
  icon: Video,
  title: 'Creación de Contenido',
  subtitle: 'Reels y Anuncios',
  accent: 'from-blue-700 to-zinc-900'
}];
export function Preview() {
  return <section className="py-20 md:py-28 bg-zinc-950 relative overflow-hidden" data-id="element-233">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] bg-blue-600/10 rounded-full blur-[100px] pointer-events-none" data-id="element-234"></div>

      <div className="max-w-6xl mx-auto px-4 md:px-6 relative z-10" data-id="element-235">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14 max-w-3xl mx-auto" data-id="element-236">
          <span className="inline-block text-blue-400 text-sm font-mono font-bold mb-3 uppercase tracking-wider" data-id="element-237">
            Vista previa
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight mb-4" data-id="element-238">
            Esto es lo que vas a encontrar adentro
          </h2>
          <p className="text-lg text-zinc-400" data-id="element-239">
            Tres recursos pensados para trabajar juntos: la guía principal más
            dos bonus enfocados en campañas y contenido.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6" data-id="element-240">
          {items.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.12
          }} className="group" data-id="element-241">
                {/* PDF mockup card */}
                <div className={`relative aspect-[3/4] rounded-2xl bg-gradient-to-br ${item.accent} p-6 flex flex-col justify-between shadow-2xl border border-white/10 overflow-hidden`} data-id="element-242">
                  {/* Subtle grid overlay */}
                  <div className="absolute inset-0 opacity-[0.07] pointer-events-none" style={{
                backgroundImage: 'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)',
                backgroundSize: '32px 32px'
              }} data-id="element-243"></div>

                  {/* Top */}
                  <div className="relative z-10" data-id="element-244">
                    <div className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white text-[10px] font-bold uppercase tracking-wider mb-4" data-id="element-245">
                      {item.label}
                    </div>
                    <Icon className="w-10 h-10 text-white/90 mb-3" data-id="element-246" />
                  </div>

                  {/* Bottom */}
                  <div className="relative z-10" data-id="element-247">
                    <h3 className="text-white font-extrabold text-xl md:text-2xl leading-tight mb-1.5" data-id="element-248">
                      {item.title}
                    </h3>
                    <p className="text-white/70 text-sm font-medium" data-id="element-249">
                      {item.subtitle}
                    </p>
                    <div className="mt-4 pt-4 border-t border-white/15 flex items-center gap-2 text-white/60 text-[10px] font-mono uppercase tracking-wider" data-id="element-250">
                      <span className="w-1.5 h-1.5 rounded-full bg-white/50" data-id="element-251"></span>
                      PDF · Acceso digital
                    </div>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}